import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    heiress: [
//          {
//              name: 'テスト相続人1',
//              birthday: '1987-12-15',
//              relationship: '妻'
//          },
//          {
//              name: 'テスト相続人2',
//              birthday: '1998-10-19',
//              relationship: '長女'
//          },
//          {
//              name: 'テスト相続人3',
//              birthday: '2005-04-01',
//              relationship: '長女'
//          }
    ]
};

const slice = createSlice({
    name: 'heiress',
    initialState,
    reducers: {
        setHeiress: (state, action) => {
            return Object.assign({}, state, { heiress: state.heiress.concat(action.payload) })
        },
        clearHeiress: (state, action) => {
            const newArray = Array.from(new Set([...state.heiress]));
            newArray.splice(action.payload, 1)
            return Object.assign({}, state, { heiress: newArray })
        },
    }
});


export default slice.reducer;

export const {
    setHeiress,
    clearHeiress,
} = slice.actions;
